/* series*/

// children
import child_img1_s from "./images/series/children/arthur/small.jpg";
import child_img1_l from "./images/series/children/arthur/large.jpg";
import child_img3_s from "./images/series/children/dora-the-explorer/small.jpg";
import child_img3_l from "./images/series/children/dora-the-explorer/large.jpg";
import child_img4_s from "./images/series/children/paw-patrol/small.jpg";
import child_img4_l from "./images/series/children/paw-patrol/large.jpg";
import child_img2_s from "./images/series/children/peppa-pig/small.jpg";
import child_img2_l from "./images/series/children/peppa-pig/large.jpg";
import child_img5_s from "./images/series/children/spongebob/small.jpg";
import child_img5_l from "./images/series/children/spongebob/large.jpg";
// comedian
import comedy_img1_s from "./images/series/comedies/arrested-development/small.jpg";
import comedy_img1_l from "./images/series/comedies/arrested-development/large.jpg";
import comedy_img2_s from "./images/series/comedies/curb-your-enthusiasm/small.jpg";
import comedy_img2_l from "./images/series/comedies/curb-your-enthusiasm/large.jpg";
import comedy_img3_s from "./images/series/comedies/family-guy/small.jpg";
import comedy_img3_l from "./images/series/comedies/family-guy/large.jpg";
import comedy_img4_s from "./images/series/comedies/south-park/small.jpg";
import comedy_img4_l from "./images/series/comedies/south-park/large.jpg";
import comedy_img5_s from "./images/series/comedies/the-office/small.jpg";
import comedy_img5_l from "./images/series/comedies/the-office/large.jpg";
// crime
import crime_img1_s from "./images/series/crime/long-shot/small.jpg";
import crime_img1_l from "./images/series/crime/long-shot/large.jpg";
import crime_img2_s from "./images/series/crime/making-a-murderer/small.jpg";
import crime_img2_l from "./images/series/crime/making-a-murderer/large.jpg";
import crime_img3_s from "./images/series/crime/the-confession-killer/small.jpg";
import crime_img3_l from "./images/series/crime/the-confession-killer/large.jpg";
import the_innocent_man_s from "./images/series/crime/the-innocent-man/small.jpg";
import the_innocent_man_l from "./images/series/crime/the-innocent-man/large.jpg";
import the_staircase_s from "./images/series/crime/the-staircase/small.jpg";
import the_staircase_l from "./images/series/crime/the-staircase/large.jpg";

// documentries
import doc_img1_s from "./images/series/documentaries/tiger-king/small.jpg";
import doc_img1_l from "./images/series/documentaries/tiger-king/large.jpg";
import doc_img2_s from "./images/series/documentaries/amanda-knox/small.jpg";
import doc_img2_l from "./images/series/documentaries/amanda-knox/large.jpg";
import doc_img3_s from "./images/series/documentaries/man-on-wire/small.jpg";
import doc_img3_l from "./images/series/documentaries/man-on-wire/large.jpg";
import super_size_me_s from "./images/series/documentaries/super-size-me/small.jpg";
import super_size_me_l from "./images/series/documentaries/super-size-me/large.jpg";
import doc_img6_s from "./images/series/documentaries/citizenfour/small.jpg";
import doc_img6_l from "./images/series/documentaries/citizenfour/large.jpg";
//feel-good
import feel_img1_s from "./images/series/feel-good/forrest-gump/small.jpg";
import feel_img1_l from "./images/series/feel-good/forrest-gump/large.jpg";
import feel_img2_s from "./images/series/feel-good/good-will-hunting/small.jpg";
import feel_img2_l from "./images/series/feel-good/good-will-hunting/large.jpg";
import feel_img3_s from "./images/series/feel-good/juno/small.jpg";
import feel_img3_l from "./images/series/feel-good/juno/large.jpg";
import feel_img4_s from "./images/series/feel-good/midnight-in-paris/small.jpg";
import feel_img4_l from "./images/series/feel-good/midnight-in-paris/large.jpg";
import feel_img5_s from "./images/series/feel-good/school-of-rock/small.jpg";
import feel_img5_l from "./images/series/feel-good/school-of-rock/large.jpg";

/* films*/
// children
import films_child_img1_s from "./images/films/children/despicable-me/small.jpg";
import films_child_img1_l from "./images/films/children/despicable-me/large.jpg";
import films_child_img3_s from "./images/films/children/frozen/small.jpg";
import films_child_img3_l from "./images/films/children/frozen/large.jpg";
import films_child_img4_s from "./images/films/children/hotel-transylvania/small.jpg";
import films_child_img4_l from "./images/films/children/hotel-transylvania/large.jpg";
import films_child_img2_s from "./images/films/children/spirited-away/small.jpg";
import films_child_img2_l from "./images/films/children/spirited-away/large.jpg";
import films_child_img5_s from "./images/films/children/up/small.jpg";
import films_child_img5_l from "./images/films/children/up/large.jpg";
// drama
import drama_img1_s from "./images/films/drama/fight-club/small.jpg";
import drama_img1_l from "./images/films/drama/fight-club/large.jpg";
import drama_img2_s from "./images/films/drama/kings-speech/small.jpg";
import drama_img2_l from "./images/films/drama/kings-speech/large.jpg";
import drama_img3_s from "./images/films/drama/the-prestige/small.jpg";
import drama_img3_l from "./images/films/drama/the-prestige/large.jpg";
import drama_img4_s from "./images/films/drama/the-revenant/small.jpg";
import drama_img4_l from "./images/films/drama/the-revenant/large.jpg";
import drama_img5_s from "./images/films/drama/the-social-network/small.jpg";
import drama_img5_l from "./images/films/drama/the-social-network/large.jpg";
// romance
import a_star_is_born_s from "./images/films/romance/a-star-is-born/small.jpg";
import a_star_is_born_l from "./images/films/romance/a-star-is-born/large.jpg";
import blue_valentine_s from "./images/films/romance/blue-valentine/small.jpg";
import blue_valentine_l from "./images/films/romance/blue-valentine/large.jpg";
import la_la_land_s from "./images/films/romance/la-la-land/small.jpg";
import la_la_land_l from "./images/films/romance/la-la-land/large.jpg";
import the_notebook_s from "./images/films/romance/the-notebook/small.jpg";
import the_notebook_l from "./images/films/romance/the-notebook/large.jpg";
import titanic_s from "./images/films/romance/titanic/small.jpg";
import titanic_l from "./images/films/romance/titanic/large.jpg";

// suspense
import suspense_img1_s from "./images/films/suspense/gone-girl/small.jpg";
import suspense_img1_l from "./images/films/suspense/gone-girl/large.jpg";
import suspense_img2_s from "./images/films/suspense/prisoners/small.jpg";
import suspense_img2_l from "./images/films/suspense/prisoners/large.jpg";
import suspense_img3_s from "./images/films/suspense/seven/small.jpg";
import suspense_img3_l from "./images/films/suspense/seven/large.jpg";
import suspense_img4_s from "./images/films/suspense/shutter-island/small.jpg";
import suspense_img4_l from "./images/films/suspense/shutter-island/large.jpg";
import suspense_img5_s from "./images/films/suspense/zodiac/small.jpg";
import suspense_img5_l from "./images/films/suspense/zodiac/large.jpg";
//thriller
import thriller_img1_s from "./images/films/thriller/a-quiet-place/small.jpg";
import thriller_img1_l from "./images/films/thriller/a-quiet-place/large.jpg";
import black_swan_s from "./images/films/thriller/black-swan/small.jpg";
import black_swan_l from "./images/films/thriller/black-swan/large.jpg";
import thriller_img3_s from "./images/films/thriller/joker/small.jpg";
import thriller_img3_l from "./images/films/thriller/joker/large.jpg";
import nightcrawler_s from "./images/films/thriller/nightcrawler/small.jpg";
import nightcrawler_l from "./images/films/thriller/nightcrawler/large.jpg";
import thriller_img5_s from "./images/films/thriller/the-silence-of-the-lambs/small.jpg";
import thriller_img5_l from "./images/films/thriller/the-silence-of-the-lambs/large.jpg";

const data = [
  /* series*/
  // Documentaries
  {
    id: 1,
    title: "Tiger King",
    description:
      "An exploration of big cat breeding and its bizarre underworld, populated by eccentric characters.",
    genre: "documentaries",
    maturity: "18",
    slug: "tiger-king",
    img1: doc_img1_s,
    img2: doc_img1_l,
  },
  {
    id: 2,
    title: "Amanda Knox",
    description:
      "Amanda Marie Knox is an American woman who spent almost four years in an Italian prison.",
    genre: "documentaries",
    maturity: "12",
    slug: "amanda-knox",
    img1: doc_img2_s,
    img2: doc_img2_l,
  },
  {
    id: 3,
    title: "Citizenfour",
    description:
      "Citizenfour is a 2014 documentary film directed by Laura Poitras, concerning Edward Snowden and the NSA spying scandal.",
    genre: "documentaries",
    maturity: "12",
    slug: "citizenfour",
    img1: doc_img6_s,
    img2: doc_img6_l,
  },
  {
    id: 4,
    title: "Super Size Me",
    description:
      "Director Morgan Spurlock's social experiment in fast-food gastronomy sees him attempting to subsist uniquely on food from the McDonalds",
    genre: "documentaries",
    maturity: "12",
    slug: "super-size-me",
    img1: super_size_me_s,
    img2: super_size_me_l,
  },
  {
    id: 5,
    title: "Man on Wire",
    description:
      "Filmmaker James Marsh masterfully recreates high-wire daredevil Philippe Petit's 1974 stunt walking on a wire across the Twin Towers.",
    genre: "documentaries",
    maturity: "12",
    slug: "man-on-wire",
    img1: doc_img3_s,
    img2: doc_img3_l,
  },

  // Comedies
  {
    id: 6,
    title: "The Office",
    description:
      "A motley group of office workers go through hilarious misadventures at the Scranton, Pennsylvania, branch of the Dunder Mifflin Paper Company.",
    genre: "comedies",
    maturity: "15",
    slug: "the-office",
    img1: comedy_img5_s,
    img2: comedy_img5_l,
  },
  {
    id: 7,
    title: "Arrested Development",
    description:
      "The Bluth family, once a prominent name in the business, loses everything after the head patriarch gets convicted for fraud.",
    genre: "comedies",
    maturity: "15",
    slug: "arrested-development",
    img1: comedy_img1_s,
    img2: comedy_img1_l,
  },
  {
    id: 8,
    title: "Curb Your Enthusiasm",
    description:
      "Larry David, a famous television writer and producer, gets into various misadventures with his friends and celebrity colleagues in Los Angeles.",
    genre: "comedies",
    maturity: "15",
    slug: "curb-your-enthusiasm",
    img1: comedy_img2_s,
    img2: comedy_img2_l,
  },
  {
    id: 9,
    title: "Family Guy",
    description:
      "Peter Griffin and his family of two teenagers, a smart dog, a devilish baby and his wife find themselves in some of the most hilarious scenarios.",
    genre: "comedies",
    maturity: "15",
    slug: "family-guy",
    img1: comedy_img3_s,
    img2: comedy_img3_l,
  },
  {
    id: 10,
    title: "South Park",
    description:
      "Four young, schoolgoing boys, Stan Marsh, Kyle Broflovski, Eric Cartman and Kenny McCormick, who live in South Park set out on various adventures.",
    genre: "comedies",
    maturity: "15",
    slug: "south-park",
    img1: comedy_img4_s,
    img2: comedy_img4_l,
  },

  // Children
  {
    id: 11,
    title: "Peppa Pig",
    description:
      "Peppa, an outgoing preschool pig, participates in many energetic activities. She learns something new every day and has a lot of fun with her family and friends.",
    genre: "cartoon",
    maturity: "0",
    slug: "peppa-pig",
    img1: child_img2_s,
    img2: child_img2_l,
  },
  {
    id: 12,
    title: "Dora The Explorer",
    description:
      "Dora, a seven-year-old girl of Latin American descent, embarks upon numerous adventures in the wilderness with her friend Boots, a monkey, and a variety of fun and useful tools.",
    genre: "cartoon",
    maturity: "0",
    slug: "dora-the-explorer",
    img1: child_img3_s,
    img2: child_img3_l,
  },
  {
    id: 13,
    title: "PAW Patrol",
    description:
      "Six brave puppies, captained by a tech-savvy ten-year-old boy, Ryder, work together to accomplish high-stakes rescue missions to safeguard the residents of the Adventure Bay community.",
    genre: "cartoon",
    maturity: "0",
    slug: "paw-patrol",
    img1: child_img4_s,
    img2: child_img4_l,
  },
  {
    id: 14,
    title: "Arthur",
    description:
      "Bespectacled aardvark Arthur Read demonstrates to kids how to deal with such childhood traumas and challenges as homework, teachers and bullies.",
    genre: "cartoon",
    maturity: "0",
    slug: "arthur",
    img1: child_img1_s,
    img2: child_img1_l,
  },
  {
    id: 15,
    title: "SpongeBob",
    description:
      "A yellow sea sponge named SpongeBob SquarePants lives in the city of Bikini Bottom deep in the Pacific Ocean. ",
    genre: "cartoon",
    maturity: "0",
    slug: "spongebob",
    img1: child_img5_s,
    img2: child_img5_l,
  },

  // Crime
  {
    id: 16,
    title: "Making a Murderer",
    description:
      "Exonerated after spending nearly two decades in prison for a crime he did not commit, Steven Avery filed suit against Manitowoc County, Wis., and several individuals involved with his arrest.",
    genre: "crime",
    maturity: "18",
    slug: "making-a-murderer",
    img1: crime_img2_s,
    img2: crime_img2_l,
  },
  {
    id: 17,
    title: "Long Shot",
    description:
      "An innocent man is accused of murder, leading his attorney on a wild chase to confirm his alibi using raw footage from a television show.",
    genre: "crime",
    maturity: "18",
    slug: "long-shot",
    img1: crime_img1_s,
    img2: crime_img1_l,
  },
  {
    id: 18,
    title: "The Confession Killer",
    description:
      "Henry Lee Lucas was an American convicted serial killer whose crimes spanned from 1960 to 1983.",
    genre: "crime",
    maturity: "18",
    slug: "the-confession-killer",
    img1: crime_img3_s,
    img2: crime_img3_l,
  },
  {
    id: 19,
    title: "The Innocent Man",
    description:
      "He was convicted of murdering eleven people and condemned to death for the murder of Debra Jackson.",
    genre: "crime",
    maturity: "18",
    slug: "the-innocent-man",
    img1: the_innocent_man_s,
    img2: the_innocent_man_l,
  },
  {
    id: 20,
    title: "The Staircase",
    description:
      "In 2001 novelist Michael Peterson's wife died, and he claimed she perished after falling down stairs at their home. The medical examiner, however, determined that she had been beaten with a weapon",
    genre: "crime",
    maturity: "18",
    slug: "the-staircase",
    img1: the_staircase_s,
    img2: the_staircase_l,
  },

  // Feel-good
  {
    id: 21,
    title: "Good Will Hunting",
    description:
      "Will Hunting, a genius in mathematics, solves all the difficult mathematical problems. When he faces an emotional crisis, he takes help from psychiatrist Dr Sean Maguireto, who helps him recover.",
    genre: "feel-good",
    maturity: "12",
    slug: "good-will-hunting",
    img1: feel_img2_s,
    img2: feel_img2_l,
  },
  {
    id: 22,
    title: "Forrest Gump",
    description:
      "Forrest Gump, a man with a low IQ, joins the army for service where he meets Dan and Bubba. However, he cannot stop thinking about his childhood sweetheart Jenny Curran, whose life is messed up.",
    genre: "feel-good",
    maturity: "12",
    slug: "forrest-gump",
    img1: feel_img1_s,
    img2: feel_img1_l,
  },
  {
    id: 23,
    title: "Juno",
    description:
      "Social misfit Juno protects herself with a caustic wit, but her unplanned pregnancy has the teen getting more involved in the lives of her baby's adoptive parents than she expected.",
    genre: "feel-good",
    maturity: "12",
    slug: "juno",
    img1: feel_img3_s,
    img2: feel_img3_l,
  },
  {
    id: 24,
    title: "Midnight In Paris",
    description:
      "Gil arrives with his fiancee and her family in Paris for a vacation, even as he tries to finish his debut novel. He is beguiled by the city, which takes him to a time past, away from his fiancee.",
    genre: "feel-good",
    maturity: "12",
    slug: "midnight-in-paris",
    img1: feel_img4_s,
    img2: feel_img4_l,
  },
  {
    id: 25,
    title: "School of Rock",
    description:
      "Dewey Finn, an amateur rock enthusiast, slyly takes up his friend's substitute teacher's job. Bearing no qualifications for it, he instead starts training the students to form a band.",
    genre: "feel-good",
    maturity: "12",
    slug: "school-of-rock",
    img1: feel_img5_s,
    img2: feel_img5_l,
  },

  /* Films
    ============================================ */
  // Drama
  {
    id: 26,
    title: "The Prestige",
    description:
      "Two friends and fellow magicians become bitter enemies after a sudden tragedy. As they devote themselves to this rivalry, they make sacrifices that bring them fame but with terrible consequences.",
    genre: "drama",
    maturity: "15",
    slug: "the-prestige",
    img1: drama_img3_s,
    img2: drama_img3_l,
  },
  {
    id: 27,
    title: "Fight Club",
    description:
      "Discontented with his capitalistic lifestyle, a white-collared insomniac forms an underground fight club with Tyler, a careless soap salesman. The project soon spirals down into something sinister.",
    genre: "drama",
    maturity: "15",
    slug: "fight-club",
    img1: drama_img1_s,
    img2: drama_img1_l,
  },
  {
    id: 28,
    title: "Kings Speech",
    description:
      "King George VI tries to overcome his stammering problem with the help of speech therapist Lionel Logue and makes himself worthy enough to lead his country through World War II.",
    genre: "drama",
    maturity: "15",
    slug: "kings-speech",
    img1: drama_img2_s,
    img2: drama_img2_l,
  },
  {
    id: 29,
    title: "The Revenant",
    description:
      "Hugh Glass, a legendary frontiersman, is severely injured in a bear attack and is abandoned by his hunting crew. He uses his skills to survive and take revenge on his companion, who betrayed him.",
    genre: "drama",
    maturity: "15",
    slug: "the-revenant",
    img1: drama_img4_s,
    img2: drama_img4_l,
  },
  {
    id: 30,
    title: "The Social Network",
    description:
      "Mark Zuckerberg creates a social networking site, Facebook, with the help of his friend Eduardo Saverin.",
    genre: "drama",
    maturity: "12",
    slug: "the-social-network",
    img1: drama_img5_s,
    img2: drama_img5_l,
  },

  // Suspense
  {
    id: 31,
    title: "Shutter Island",
    description:
      "Teddy Daniels and Chuck Aule, two US marshals, are sent to an asylum on a remote island in order to investigate the disappearance of a patient, where Teddy uncovers a shocking truth about the place.",
    genre: "suspense",
    maturity: "15",
    slug: "shutter-island",
    img1: suspense_img4_s,
    img2: suspense_img4_l,
  },
  {
    id: 32,
    title: "Gone Girl",
    description:
      "Nick Dunne discovers that the entire media focus has shifted on him when his wife Amy Dunne disappears on the day of their fifth wedding anniversary.",
    genre: "suspense",
    maturity: "15",
    slug: "gone-girl",
    img1: suspense_img1_s,
    img2: suspense_img1_l,
  },
  {
    id: 33,
    title: "Prisoners",
    description:
      "When the police take time to find Keller Dover's daughter and her friend, he decides to go on a search himself. His desperation leads him closer to finding the truth and also jeopardises his own life.",
    genre: "suspense",
    maturity: "15",
    slug: "prisoners",
    img1: suspense_img2_s,
    img2: suspense_img2_l,
  },
  {
    id: 34,
    title: "Seven",
    description:
      "A serial killer begins murdering people according to the seven deadly sins. Two detectives, one new to the city and the other about to retire, are tasked with apprehending the criminal.",
    genre: "suspense",
    maturity: "15",
    slug: "seven",
    img1: suspense_img3_s,
    img2: suspense_img3_l,
  },
  {
    id: 35,
    title: "Zodiac",
    description:
      "Robert Graysmith, a cartoonist by profession, finds himself obsessively thinking about the Zodiac killer. He uses his puzzle-solving abilities to get closer to revealing the identity of the killer.",
    genre: "suspense",
    maturity: "15",
    slug: "zodiac",
    img1: suspense_img5_s,
    img2: suspense_img5_l,
  },

  // Children
  {
    id: 36,
    title: "Hotel Transylvania",
    description:
      "Dracula, who owns a high-end resort for monsters, attempts to keep his daughter from falling in love with Jonathan, a human.",
    genre: "children",
    maturity: "0",
    slug: "hotel-transylvania",
    img1: films_child_img4_s,
    img2: films_child_img4_l,
  },
  {
    id: 37,
    title: "Despicable Me",
    description:
      "Gru, a criminal mastermind, adopts three orphans as pawns to carry out the biggest heist in history. His life takes an unexpected turn when the little girls see him as their potential father.",
    genre: "children",
    maturity: "0",
    slug: "despicable-me",
    img1: films_child_img1_s,
    img2: films_child_img1_l,
  },
  {
    id: 38,
    title: "Frozen",
    description:
      "Anna sets out on a journey with an iceman, Kristoff, and his reindeer, Sven, in order to find her sister, Elsa, who has the power to convert any object or person into ice.",
    genre: "children",
    maturity: "0",
    slug: "frozen",
    img1: films_child_img3_s,
    img2: films_child_img3_l,
  },
  {
    id: 39,
    title: "Spirited Away",
    description:
      "In this animated feature by noted Japanese director Hayao Miyazaki, 10-year-old Chihiro  and her parents stumble upon a seemingly abandoned amusement park.",
    genre: "children",
    maturity: "0",
    slug: "spirited-away",
    img1: films_child_img2_s,
    img2: films_child_img2_l,
  },
  {
    id: 40,
    title: "Up",
    description:
      "Carl, an old widower, goes off on an adventure in his flying house in search of Paradise Falls, his wife's dream destination.",
    genre: "children",
    maturity: "0",
    slug: "up",
    img1: films_child_img5_s,
    img2: films_child_img5_l,
  },

  // Thriller
  {
    id: 41,
    title: "Joker",
    description:
      "Forever alone in a crowd, failed comedian Arthur Fleck seeks connection as he walks the streets of Gotham City.",
    genre: "thriller",
    maturity: "15",
    slug: "joker",
    img1: thriller_img3_s,
    img2: thriller_img3_l,
  },
  {
    id: 42,
    title: "A Quiet Place",
    description:
      "The Abbott family must now face the terrors of the outside world as they fight for survival in silence.",
    genre: "thriller",
    maturity: "15",
    slug: "a-quiet-place",
    img1: thriller_img1_s,
    img2: thriller_img1_l,
  },
  {
    id: 43,
    title: "Black Swan",
    description:
      "Nina, a ballerina, gets the chance to play the White Swan, Princess Odette. But she finds herself slipping into madness when Thomas, the artistic director, decides that Lily might fit the role better.",
    genre: "thriller",
    maturity: "15",
    slug: "black-swan",
    img1: black_swan_s,
    img2: black_swan_l,
  },
  {
    id: 44,
    title: "Nightcrawler",
    description:
      "Louis Bloom, a petty thief, realises that he can make money by capturing photographs of criminal activities and starts resorting to extreme tactics to get them.",
    genre: "thriller",
    maturity: "15",
    slug: "nightcrawler",
    img1: nightcrawler_s,
    img2: nightcrawler_l,
  },
  {
    id: 45,
    title: "The Silence of The Lambs",
    description:
      "Clarice Starling, an FBI agent, seeks help from Hannibal Lecter, a psychopathic serial killer and former psychiatrist, in order to apprehend another serial killer who has been claiming female victims.",
    genre: "thriller",
    maturity: "15",
    slug: "the-silence-of-the-lambs",
    img1: thriller_img5_s,
    img2: thriller_img5_l,
  },

  // Romance
  {
    id: 46,
    title: "A Star Is Born",
    description:
      "After falling in love with struggling artist Ally, Jackson, a musician, coaxes her to follow her dreams, while he battles with alcoholism and his personal demons.",
    genre: "romance",
    maturity: "15",
    slug: "a-star-is-born",
    img1: a_star_is_born_s,
    img2: a_star_is_born_l,
  },
  {
    id: 47,
    title: "Blue Valentine",
    description:
      "Dean and Cynthia are married with a daughter and their marriage is about to fall apart. Both come from dysfunctional families and struggle to make sense of their relationship.",
    genre: "romance",
    maturity: "15",
    slug: "blue-valentine",
    img1: blue_valentine_s,
    img2: blue_valentine_l,
  },
  {
    id: 48,
    title: "La La Land",
    description:
      "Sebastian (Ryan Gosling) and Mia (Emma Stone) are drawn together by their common desire to do what they love. But as success mounts they are faced with decisions that begin...",
    genre: "romance",
    maturity: "15",
    slug: "la-la-land",
    img1: la_la_land_s,
    img2: la_la_land_l,
  },
  {
    id: 49,
    title: "The Notebook",
    description:
      "Duke reads the story of Allie and Noah, two lovers who were separated by fate, to Ms Hamilton, an old woman who suffers from Alzheimer's, on a daily basis out of his notebook.",
    genre: "romance",
    maturity: "15",
    slug: "the-notebook",
    img1: the_notebook_s,
    img2: the_notebook_l,
  },
  {
    id: 50,
    title: "Titanic",
    description:
      "Seventeen-year-old Rose hails from an aristocratic family and is set to be married. When she boards the Titanic, she meets Jack Dawson, an artist, and falls in love with him.",
    genre: "romance",
    maturity: "15",
    slug: "titanic",
    img1: titanic_s,
    img2: titanic_l,
  },
];

export default data;
